import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestHandlerService, RequestOptionsModel } from "bbsf-utilities";
import { WFCreationModel } from "../models/WorkflowModels/WFCreationModel";



@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  ApiUrl = "/api/admin/Workflow/"
  constructor(private http: RequestHandlerService) {
  }


  AddWorkflow( AddModel: WFCreationModel) {
    return this.http.post( this.ApiUrl + 'AddWorkflow', AddModel);
  }

  EditWorkflow(EditModel: WFCreationModel) {
    return this.http.post( this.ApiUrl + 'EditWorkflow', EditModel);
  }

  GetDetails(Id:string) {
    let params = new HttpParams();
    params = params.append("wfId",Id);
    return this.http.get( this.ApiUrl + 'Details',params);
  }

  
}